const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/users/$userId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
import * as z from "zod";
export const Route = createFileRoute("/client/users/$userId")({
  beforeLoad: args => requirePermission(Permissions.ClientUsers.ViewAll, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
const userSchema = z.object({
  externalId: z.string().optional(),
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.union([z.literal(""), z.string().email("Invalid email address")]),
  jobTitle: z.string().optional(),
  notes: z.string().optional(),
  isActive: z.boolean()
});
type UserFormValues = z.infer<typeof userSchema>;